import { render, staticRenderFns } from "./PerfilDemograficoChart.vue?vue&type=template&id=64951c13"
import script from "./PerfilDemograficoChart.vue?vue&type=script&lang=js"
export * from "./PerfilDemograficoChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports